import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../lang/en-us';
import SuccessScreen from '../../dashboard/makeNct/SuccessScreen';
const { dashboard } = en;

export default function UpdatePanSuccess(props: any) {
    const { reqId = '' } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);
    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.UpdatePan.Success.back}
                backLink="/investor/signin"
                info1={dashboard.UpdatePan.Success.subHeadingInfo1}
                infospan1="“AVEOY9087K”"
                info2={dashboard.UpdatePan.Success.subHeadingInfo2}
                infospan2={`${reqId}`}
                info3={dashboard.UpdatePan.Success.subHeadingInfo3}
                handleClick={() => props.history.push('/')}
                condition={'update-pan'}
            />
        </div>
    );
}
